// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cf-footer {
  background: #ffffff;
  color: #0b0b0f;
  border-top: 1px solid rgba(0,0,0,0.08);
}

.cf-footer__inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
  justify-content: space-between;
}

.cf-footer__brand {
  min-width: 200px;
}

.cf-footer__logo {
  font-weight: 700;
  letter-spacing: 0.2px;
  font-size: 15px;
  margin-bottom: 6px;
}

.cf-footer__tagline {
  margin: 0;
  color: #52525b;
  font-size: 12px;
}

.cf-footer__links {
  display: flex;
  gap: 32px;
}

.cf-footer__column {
  min-width: 140px;
}

.cf-footer__heading {
  margin: 0 0 10px 0;
  font-size: 12px;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cf-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 6px;
}

.cf-footer__link {
  color: #374151;
  text-decoration: none;
  font-size: 12px;
}

.cf-footer__link:hover {
  color: #111827;
}

.cf-footer__bottom {
  border-top: 1px solid rgba(0,0,0,0.08);
  text-align: center;
  padding: 12px 20px 16px;
  color: #6b7280;
  font-size: 11px;
}

.cf-footer__copyright {
  margin: 0;
}

.cf-footer__separator {
  margin: 0 8px;
}

.cf-footer__bottom-link {
  color: #28a745;
  text-decoration: none;
  font-weight: 500;
}

.cf-footer__bottom-link:hover {
  text-decoration: underline;
}

@media (max-width: 720px) {
  .cf-footer__links {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".cf-footer {\n  background: #ffffff;\n  color: #0b0b0f;\n  border-top: 1px solid rgba(0,0,0,0.08);\n}\n\n.cf-footer__inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 32px 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.cf-footer__brand {\n  min-width: 200px;\n}\n\n.cf-footer__logo {\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  font-size: 15px;\n  margin-bottom: 6px;\n}\n\n.cf-footer__tagline {\n  margin: 0;\n  color: #52525b;\n  font-size: 12px;\n}\n\n.cf-footer__links {\n  display: flex;\n  gap: 32px;\n}\n\n.cf-footer__column {\n  min-width: 140px;\n}\n\n.cf-footer__heading {\n  margin: 0 0 10px 0;\n  font-size: 12px;\n  color: #111827;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cf-footer__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.cf-footer__link {\n  color: #374151;\n  text-decoration: none;\n  font-size: 12px;\n}\n\n.cf-footer__link:hover {\n  color: #111827;\n}\n\n.cf-footer__bottom {\n  border-top: 1px solid rgba(0,0,0,0.08);\n  text-align: center;\n  padding: 12px 20px 16px;\n  color: #6b7280;\n  font-size: 11px;\n}\n\n.cf-footer__copyright {\n  margin: 0;\n}\n\n.cf-footer__separator {\n  margin: 0 8px;\n}\n\n.cf-footer__bottom-link {\n  color: #28a745;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.cf-footer__bottom-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 720px) {\n  .cf-footer__links {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
